
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M1.142 19.734a.091.091 0 0 0-.005.173l5.078 1.869v.348c0 .577.122 6.963.781 7.66.667.706 1.75 1.385 3.218 1.972 1.462.585 3.242 1.052 5.23 1.368 1.987.315 4.129.47 6.288.454a38 38 0 0 0 6.234-.547c1.954-.344 3.682-.837 5.08-1.44 1.403-.608 2.406-1.298 2.99-2.002.548-.66.538-6.31.536-7.353v-.475l5.039-1.854a.091.091 0 0 0-.005-.173l-20.18-6.07a.2.2 0 0 0-.105 0z"}}),_c('circle',{attrs:{"cx":"12.863","cy":"38.042","r":"1.963","fill":"#D0EFEC"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M14.037 35.5V20.762l10.496-4.015"}}),_c('circle',{attrs:{"cx":"14","cy":"37","r":"1.5","stroke":"#234652"}}),_c('path',{attrs:{"stroke":"#234652","d":"M3.783 17.07a.091.091 0 0 1 .006-.173l20.179-6.07a.2.2 0 0 1 .105 0l20.18 6.07a.091.091 0 0 1 .005.173l-20.174 7.423a.18.18 0 0 1-.127 0z","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","d":"M39.219 19.287c0 .632.037 6.776-.535 7.465-.585.704-1.588 1.394-2.992 2.001-1.397.604-3.125 1.097-5.079 1.441-1.951.345-4.075.531-6.234.547-2.16.016-4.301-.14-6.288-.454-1.988-.316-3.768-.784-5.23-1.368-1.468-.587-2.551-1.266-3.218-1.972-.659-.697-.782-7.083-.781-7.66"}})])
          )
        }
      }
    